function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }

import _regeneratorRuntime from "@babel/runtime/regenerator";

function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }

function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }

function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }

function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }

function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }

function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }

function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }

function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }

function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }

function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }

function _classPrivateFieldLooseBase(receiver, privateKey) {
  if (!Object.prototype.hasOwnProperty.call(receiver, privateKey)) {
    throw new TypeError("attempted to use private field on non-instance");
  }

  return receiver;
}

var id = 0;

function _classPrivateFieldLooseKey(name) {
  return "__private_" + id++ + "_" + name;
}

import { nanoid } from 'nanoid/non-secure';
import { Provider, RequestClient, Socket } from '@uppy/companion-client';
import emitSocketProgress from '@uppy/utils/lib/emitSocketProgress';
import getSocketHost from '@uppy/utils/lib/getSocketHost';
import EventTracker from '@uppy/utils/lib/EventTracker';
import ProgressTimeout from '@uppy/utils/lib/ProgressTimeout';
import ErrorWithCause from '@uppy/utils/lib/ErrorWithCause';
import NetworkError from '@uppy/utils/lib/NetworkError';
import isNetworkError from '@uppy/utils/lib/isNetworkError';
import { internalRateLimitedQueue } from '@uppy/utils/lib/RateLimitedQueue'; // See XHRUpload

function buildResponseError(xhr, error) {
  if (isNetworkError(xhr)) return new NetworkError(error, xhr);
  var err = new ErrorWithCause('Upload error', {
    cause: error
  });
  err.request = xhr;
  return err;
} // See XHRUpload


function setTypeInBlob(file) {
  var dataWithUpdatedType = file.data.slice(0, file.data.size, file.meta.type);
  return dataWithUpdatedType;
}

function addMetadata(formData, meta, opts) {
  var allowedMetaFields = Array.isArray(opts.allowedMetaFields) ? opts.allowedMetaFields // Send along all fields by default.
  : Object.keys(meta);
  allowedMetaFields.forEach(function (item) {
    formData.append(item, meta[item]);
  });
}

function createFormDataUpload(file, opts) {
  var formPost = new FormData();
  addMetadata(formPost, file.meta, opts);
  var dataWithUpdatedType = setTypeInBlob(file);

  if (file.name) {
    formPost.append(opts.fieldName, dataWithUpdatedType, file.meta.name);
  } else {
    formPost.append(opts.fieldName, dataWithUpdatedType);
  }

  return formPost;
}

var createBareUpload = function createBareUpload(file) {
  return file.data;
};

var _queueRequestSocketToken = /*#__PURE__*/_classPrivateFieldLooseKey("queueRequestSocketToken");

var _getOptions = /*#__PURE__*/_classPrivateFieldLooseKey("getOptions");

var _addEventHandlerForFile = /*#__PURE__*/_classPrivateFieldLooseKey("addEventHandlerForFile");

var _addEventHandlerIfFileStillExists = /*#__PURE__*/_classPrivateFieldLooseKey("addEventHandlerIfFileStillExists");

var _uploadLocalFile = /*#__PURE__*/_classPrivateFieldLooseKey("uploadLocalFile");

var _requestSocketToken = /*#__PURE__*/_classPrivateFieldLooseKey("requestSocketToken");

var _uploadRemoteFile = /*#__PURE__*/_classPrivateFieldLooseKey("uploadRemoteFile");

var MiniXHRUpload = /*#__PURE__*/function () {
  function MiniXHRUpload(_uppy, _opts) {
    var _this2 = this;

    _classCallCheck(this, MiniXHRUpload);

    Object.defineProperty(this, _uploadRemoteFile, {
      value: _uploadRemoteFile2
    });
    Object.defineProperty(this, _uploadLocalFile, {
      value: _uploadLocalFile2
    });
    Object.defineProperty(this, _addEventHandlerIfFileStillExists, {
      value: _addEventHandlerIfFileStillExists2
    });
    Object.defineProperty(this, _addEventHandlerForFile, {
      value: _addEventHandlerForFile2
    });
    Object.defineProperty(this, _getOptions, {
      value: _getOptions2
    });
    Object.defineProperty(this, _queueRequestSocketToken, {
      writable: true,
      value: void 0
    });
    Object.defineProperty(this, _requestSocketToken, {
      writable: true,
      value: function () {
        var _value = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(file) {
          var opts, Client, client, allowedMetaFields, res;
          return _regeneratorRuntime.wrap(function _callee$(_context) {
            while (1) {
              switch (_context.prev = _context.next) {
                case 0:
                  opts = _classPrivateFieldLooseBase(_this2, _getOptions)[_getOptions](file);
                  Client = file.remote.providerOptions.provider ? Provider : RequestClient;
                  client = new Client(_this2.uppy, file.remote.providerOptions);
                  allowedMetaFields = Array.isArray(opts.allowedMetaFields) ? opts.allowedMetaFields // Send along all fields by default.
                  : Object.keys(file.meta);

                  if (file.tus) {
                    // Install file-specific upload overrides.
                    Object.assign(opts, file.tus);
                  }

                  _context.next = 7;
                  return client.post(file.remote.url, _objectSpread(_objectSpread({}, file.remote.body), {}, {
                    protocol: 'multipart',
                    endpoint: opts.endpoint,
                    size: file.data.size,
                    fieldname: opts.fieldName,
                    metadata: Object.fromEntries(allowedMetaFields.map(function (name) {
                      return [name, file.meta[name]];
                    })),
                    httpMethod: opts.method,
                    useFormData: opts.formData,
                    headers: opts.headers
                  }));

                case 7:
                  res = _context.sent;
                  return _context.abrupt("return", res.token);

                case 9:
                case "end":
                  return _context.stop();
              }
            }
          }, _callee);
        }));

        function value(_x) {
          return _value.apply(this, arguments);
        }

        return value;
      }()
    });
    this.uppy = _uppy;
    this.opts = _objectSpread({
      validateStatus: function validateStatus(status) {
        return status >= 200 && status < 300;
      }
    }, _opts);
    this.requests = _opts[internalRateLimitedQueue];
    this.uploaderEvents = Object.create(null);
    this.i18n = _opts.i18n;
    _classPrivateFieldLooseBase(this, _queueRequestSocketToken)[_queueRequestSocketToken] = this.requests.wrapPromiseFunction(_classPrivateFieldLooseBase(this, _requestSocketToken)[_requestSocketToken], {
      priority: -1
    });
  }

  _createClass(MiniXHRUpload, [{
    key: "uploadFile",
    value: function uploadFile(id, current, total) {
      var file = this.uppy.getFile(id);

      if (file.error) {
        throw new Error(file.error);
      } else if (file.isRemote) {
        return _classPrivateFieldLooseBase(this, _uploadRemoteFile)[_uploadRemoteFile](file, current, total);
      }

      return _classPrivateFieldLooseBase(this, _uploadLocalFile)[_uploadLocalFile](file, current, total);
    }
  }, {
    key: "connectToServerSocket",
    value: function () {
      var _connectToServerSocket = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(file) {
        var _this3 = this;

        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                return _context2.abrupt("return", new Promise(function (resolve, reject) {
                  var opts = _classPrivateFieldLooseBase(_this3, _getOptions)[_getOptions](file);

                  var token = file.serverToken;
                  var host = getSocketHost(file.remote.companionUrl);
                  var socket;

                  var createSocket = function createSocket() {
                    if (socket != null) return;
                    socket = new Socket({
                      target: "".concat(host, "/api/").concat(token)
                    });
                    socket.on('progress', function (progressData) {
                      return emitSocketProgress(_this3, progressData, file);
                    });
                    socket.on('success', function (data) {
                      var body = opts.getResponseData(data.response.responseText, data.response);
                      var uploadURL = body[opts.responseUrlFieldName];
                      var uploadResp = {
                        status: data.response.status,
                        body: body,
                        uploadURL: uploadURL,
                        bytesUploaded: data.bytesUploaded
                      };

                      _this3.uppy.emit('upload-success', file, uploadResp);

                      queuedRequest.done(); // eslint-disable-line no-use-before-define

                      // eslint-disable-line no-use-before-define
                      socket.close();

                      if (_this3.uploaderEvents[file.id]) {
                        _this3.uploaderEvents[file.id].remove();

                        _this3.uploaderEvents[file.id] = null;
                      }

                      return resolve();
                    });
                    socket.on('error', function (errData) {
                      var resp = errData.response;
                      var error = resp ? opts.getResponseError(resp.responseText, resp) : new ErrorWithCause(errData.error.message, {
                        cause: errData.error
                      });

                      _this3.uppy.emit('upload-error', file, error);

                      queuedRequest.done(); // eslint-disable-line no-use-before-define

                      // eslint-disable-line no-use-before-define
                      if (_this3.uploaderEvents[file.id]) {
                        _this3.uploaderEvents[file.id].remove();

                        _this3.uploaderEvents[file.id] = null;
                      }

                      reject(error);
                    });
                  };

                  _this3.uploaderEvents[file.id] = new EventTracker(_this3.uppy);

                  var queuedRequest = _this3.requests.run(function () {
                    if (file.isPaused) {
                      var _socket;

                      (_socket = socket) == null ? void 0 : _socket.send('pause', {});
                    } else {
                      createSocket();
                    }

                    return function () {
                      return socket.close();
                    };
                  });

                  _classPrivateFieldLooseBase(_this3, _addEventHandlerForFile)[_addEventHandlerForFile]('file-removed', file.id, function () {
                    var _socket2;

                    (_socket2 = socket) == null ? void 0 : _socket2.send('cancel', {});
                    queuedRequest.abort();
                    resolve("upload ".concat(file.id, " was removed"));
                  });

                  _classPrivateFieldLooseBase(_this3, _addEventHandlerIfFileStillExists)[_addEventHandlerIfFileStillExists]('cancel-all', file.id, function (_temp) {
                    var _ref = _temp === void 0 ? {} : _temp,
                        reason = _ref.reason;

                    if (reason === 'user') {
                      var _socket3;

                      (_socket3 = socket) == null ? void 0 : _socket3.send('cancel', {});
                      queuedRequest.abort();
                    }

                    resolve("upload ".concat(file.id, " was canceled"));
                  });

                  var onRetryRequest = function onRetryRequest() {
                    if (socket == null) {
                      queuedRequest.abort();
                    } else {
                      socket.send('pause', {});
                      queuedRequest.done();
                    }

                    queuedRequest = _this3.requests.run(function () {
                      if (!file.isPaused) {
                        if (socket == null) {
                          createSocket();
                        } else {
                          socket.send('resume', {});
                        }
                      }

                      return function () {
                        return socket.close();
                      };
                    });
                  };

                  _classPrivateFieldLooseBase(_this3, _addEventHandlerForFile)[_addEventHandlerForFile]('upload-retry', file.id, onRetryRequest);

                  _classPrivateFieldLooseBase(_this3, _addEventHandlerIfFileStillExists)[_addEventHandlerIfFileStillExists]('retry-all', file.id, onRetryRequest);
                }).catch(function (err) {
                  _this3.uppy.emit('upload-error', file, err);

                  return Promise.reject(err);
                }));

              case 1:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }));

      function connectToServerSocket(_x2) {
        return _connectToServerSocket.apply(this, arguments);
      }

      return connectToServerSocket;
    }()
  }]);

  return MiniXHRUpload;
}();

export { MiniXHRUpload as default };

function _getOptions2(file) {
  var _file$xhrUpload;

  var uppy = this.uppy;
  var overrides = uppy.getState().xhrUpload;

  var opts = _objectSpread(_objectSpread(_objectSpread(_objectSpread({}, this.opts), overrides || {}), file.xhrUpload || {}), {}, {
    headers: _objectSpread(_objectSpread(_objectSpread({}, this.opts.headers), overrides == null ? void 0 : overrides.headers), (_file$xhrUpload = file.xhrUpload) == null ? void 0 : _file$xhrUpload.headers)
  });

  return opts;
}

function _addEventHandlerForFile2(eventName, fileID, eventHandler) {
  this.uploaderEvents[fileID].on(eventName, function (fileOrID) {
    var _fileOrID$id; // TODO (major): refactor Uppy events to consistently send file objects (or consistently IDs)
    // We created a generic `addEventListenerForFile` but not all events
    // use file IDs, some use files, so we need to do this weird check.


    var id = (_fileOrID$id = fileOrID == null ? void 0 : fileOrID.id) != null ? _fileOrID$id : fileOrID;
    if (fileID === id) eventHandler();
  });
}

function _addEventHandlerIfFileStillExists2(eventName, fileID, eventHandler) {
  var _this = this;

  this.uploaderEvents[fileID].on(eventName, function () {
    if (_this.uppy.getFile(fileID)) eventHandler.apply(void 0, arguments);
  });
}

function _uploadLocalFile2(file, current, total) {
  var _this4 = this;

  var opts = _classPrivateFieldLooseBase(this, _getOptions)[_getOptions](file);

  this.uppy.log("uploading ".concat(current, " of ").concat(total));
  return new Promise(function (resolve, reject) {
    // This is done in index.js in the S3 plugin.
    // this.uppy.emit('upload-started', file)
    var data = opts.formData ? createFormDataUpload(file, opts) : createBareUpload(file, opts);
    var xhr = new XMLHttpRequest();
    _this4.uploaderEvents[file.id] = new EventTracker(_this4.uppy);
    var timer = new ProgressTimeout(opts.timeout, function () {
      xhr.abort(); // eslint-disable-next-line no-use-before-define

      queuedRequest.done();
      var error = new Error(_this4.i18n('timedOut', {
        seconds: Math.ceil(opts.timeout / 1000)
      }));

      _this4.uppy.emit('upload-error', file, error);

      reject(error);
    });
    var id = nanoid();
    xhr.upload.addEventListener('loadstart', function () {
      _this4.uppy.log("[AwsS3/XHRUpload] ".concat(id, " started"));
    });
    xhr.upload.addEventListener('progress', function (ev) {
      _this4.uppy.log("[AwsS3/XHRUpload] ".concat(id, " progress: ").concat(ev.loaded, " / ").concat(ev.total)); // Begin checking for timeouts when progress starts, instead of loading,
      // to avoid timing out requests on browser concurrency queue


      timer.progress();

      if (ev.lengthComputable) {
        _this4.uppy.emit('upload-progress', file, {
          uploader: _this4,
          bytesUploaded: ev.loaded,
          bytesTotal: ev.total
        });
      }
    });
    xhr.addEventListener('load', function (ev) {
      _this4.uppy.log("[AwsS3/XHRUpload] ".concat(id, " finished"));

      timer.done(); // eslint-disable-next-line no-use-before-define

      queuedRequest.done();

      if (_this4.uploaderEvents[file.id]) {
        _this4.uploaderEvents[file.id].remove();

        _this4.uploaderEvents[file.id] = null;
      }

      if (opts.validateStatus(ev.target.status, xhr.responseText, xhr)) {
        var _body = opts.getResponseData(xhr.responseText, xhr);

        var uploadURL = _body[opts.responseUrlFieldName];
        var uploadResp = {
          status: ev.target.status,
          body: _body,
          uploadURL: uploadURL
        };

        _this4.uppy.emit('upload-success', file, uploadResp);

        if (uploadURL) {
          _this4.uppy.log("Download ".concat(file.name, " from ").concat(uploadURL));
        }

        return resolve(file);
      }

      var body = opts.getResponseData(xhr.responseText, xhr);
      var error = buildResponseError(xhr, opts.getResponseError(xhr.responseText, xhr));
      var response = {
        status: ev.target.status,
        body: body
      };

      _this4.uppy.emit('upload-error', file, error, response);

      return reject(error);
    });
    xhr.addEventListener('error', function () {
      _this4.uppy.log("[AwsS3/XHRUpload] ".concat(id, " errored"));

      timer.done(); // eslint-disable-next-line no-use-before-define

      queuedRequest.done();

      if (_this4.uploaderEvents[file.id]) {
        _this4.uploaderEvents[file.id].remove();

        _this4.uploaderEvents[file.id] = null;
      }

      var error = buildResponseError(xhr, opts.getResponseError(xhr.responseText, xhr));

      _this4.uppy.emit('upload-error', file, error);

      return reject(error);
    });
    xhr.open(opts.method.toUpperCase(), opts.endpoint, true); // IE10 does not allow setting `withCredentials` and `responseType`
    // before `open()` is called. It’s important to set withCredentials
    // to a boolean, otherwise React Native crashes

    xhr.withCredentials = Boolean(opts.withCredentials);

    if (opts.responseType !== '') {
      xhr.responseType = opts.responseType;
    }

    Object.keys(opts.headers).forEach(function (header) {
      xhr.setRequestHeader(header, opts.headers[header]);
    });

    var queuedRequest = _this4.requests.run(function () {
      xhr.send(data);
      return function () {
        // eslint-disable-next-line no-use-before-define
        timer.done();
        xhr.abort();
      };
    }, {
      priority: 1
    });

    _classPrivateFieldLooseBase(_this4, _addEventHandlerForFile)[_addEventHandlerForFile]('file-removed', file.id, function () {
      queuedRequest.abort();
      reject(new Error('File removed'));
    });

    _classPrivateFieldLooseBase(_this4, _addEventHandlerIfFileStillExists)[_addEventHandlerIfFileStillExists]('cancel-all', file.id, function (_temp2) {
      var _ref2 = _temp2 === void 0 ? {} : _temp2,
          reason = _ref2.reason;

      if (reason === 'user') {
        queuedRequest.abort();
      }

      reject(new Error('Upload cancelled'));
    });
  });
}

function _uploadRemoteFile2(_x3) {
  return _uploadRemoteFile3.apply(this, arguments);
}

function _uploadRemoteFile3() {
  _uploadRemoteFile3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(file) {
    var serverToken;
    return _regeneratorRuntime.wrap(function _callee3$(_context3) {
      while (1) {
        switch (_context3.prev = _context3.next) {
          case 0:
            _context3.prev = 0;

            if (!file.serverToken) {
              _context3.next = 5;
              break;
            }

            _context3.next = 4;
            return this.connectToServerSocket(file);

          case 4:
            return _context3.abrupt("return", _context3.sent);

          case 5:
            _context3.next = 7;
            return _classPrivateFieldLooseBase(this, _queueRequestSocketToken)[_queueRequestSocketToken](file);

          case 7:
            serverToken = _context3.sent;

            if (this.uppy.getState().files[file.id]) {
              _context3.next = 10;
              break;
            }

            return _context3.abrupt("return", undefined);

          case 10:
            this.uppy.setFileState(file.id, {
              serverToken: serverToken
            });
            _context3.next = 13;
            return this.connectToServerSocket(this.uppy.getFile(file.id));

          case 13:
            return _context3.abrupt("return", _context3.sent);

          case 16:
            _context3.prev = 16;
            _context3.t0 = _context3["catch"](0);
            this.uppy.setFileState(file.id, {
              serverToken: undefined
            });
            this.uppy.emit('upload-error', file, _context3.t0);
            throw _context3.t0;

          case 21:
          case "end":
            return _context3.stop();
        }
      }
    }, _callee3, this, [[0, 16]]);
  }));
  return _uploadRemoteFile3.apply(this, arguments);
}